import React, { useEffect, useRef, useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const Progress = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [data, setData] = useState([]);
  const [taskData, setTaskData] = useState([]);

  const pageRef = useRef();

 const stats = [
  { icon: "📋", value: data.assigned, label: "Assigned Tasks" },
  { icon: "✅", value: data.completed, label: "Completed Tasks" },
  { icon: "❌", value: data.pending, label: "Pending Tasks" },
  { icon: "⭐", value: data.rating, label: "Rating" },
];

  const chartData = {
    labels: ["Completed", "Incomplete", "Assigned"],
    datasets: [
      {
        data: [3, 1, 4], // values matching the stats
        backgroundColor: ["#4a76a8", "#8cb0d6", "#cfdff5"],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "60%",
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  const handleDownload = () => {
    const input = pageRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("student_progress.pdf");
    });
  };

  useEffect(() => {
    callAPI("get", "student/get-student-home-data");
  }, []);

  useEffect(() => {
  if (responce?.data) {
    setTaskData(responce.data.tasks || []);
    setData({
      assigned: responce.data.assigned || 0,
      completed: responce.data.completed || 0,
      pending: responce.data.pending || 0,
      rating: responce.data.rating || 0,
    });
  }
}, [responce]);

    const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return <span className="badge bg-warning text-dark">Incomplete</span>;
      case 1:
        return <span className="badge bg-success">Completed</span>;
      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  return (
    <AdminAppBody
      content={
        <div className="container card py-4" ref={pageRef}>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-2">
            <h4 className="fw-bold mb-0">🎯 Student Task Overview</h4>
            <button className="btn btn-outline-primary align-self-md-end" onClick={handleDownload}>
              Download
            </button>
          </div>

          {/* Stats */}
          <div className="row g-3 mb-4">
  {stats.map((stat, index) => (
    <div className="col-12 col-sm-6 col-md-3" key={index}>
      <div className="border rounded p-3 text-center">
        <div className="fs-3">{stat.icon}</div>
        <div className="fw-semibold">{stat.label}</div>
        <div className="fs-5">{stat.value}</div>
      </div>
    </div>
  ))}
</div>


          {/* Chart & Task Table */}
          <div className="row g-4">
            {/* Chart */}
            <div className="col-12 col-md-6">
              <div className="border rounded p-3 h-100">
                <h6 className="fw-bold mb-3">📊 Task Distribution</h6>
                <div className="d-flex justify-content-center align-items-center" style={{ height: 220 }}>
                  <Doughnut data={chartData} options={chartOptions} />
                </div>
              </div>
            </div>

            {/* Task Table */}
            <div className="col-12 col-md-6">
              <div className="border rounded p-3 h-100">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="fw-bold mb-0">📝 Assigned Tasks</h6>
                  <a href="#" className="text-primary">
                    View All
                  </a>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>Sr. No</th>
                        <th>Task Name</th>
                        <th>Mentor</th>
                        <th>Due Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                     <tbody>
                      {taskData.length > 0 ? (
                        taskData.map((task, index) => (
                          <tr key={task.id || index}>
                            <td>{index + 1}</td>
                            <td className="fw-bold">{task.task?.task || "N/A"}</td>
                            <td>{task.mentor?.first_name || "N/A"}</td>
                            <td>{task.due_date}</td>
                            <td>{getStatusLabel(task.status)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">No tasks found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default Progress;
